import api from '@/lib/api';

const initialState = {
  backendVersion: null,
};

const mutations = {
  SET_BACKEND_VERSION(state, version) {
    state.backendVersion = version;
  },
};

const actions = {
  async fetchBackendVersion({ commit }) {
    try {
      const { data } = await api.name('getVersion').get('/version');
      commit('SET_BACKEND_VERSION', data);
    } catch (error) {
      console.error('Erreur lors de la récupération de la version du backend:', error);
    }
  },
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
};
